export const getRunDateString = (value) => {
  if (!value) return null;
  if (typeof value === 'string') {
    return value.split('T')[0];
  }
  if (typeof value.toDate === 'function') {
    return value.toDate().toISOString().split('T')[0];
  }
  try {
    return new Date(value).toISOString().split('T')[0];
  } catch {
    return null;
  }
};

export const getWeekNumber = (date) => {
  const d = new Date(date);
  d.setHours(0, 0, 0, 0);
  d.setDate(d.getDate() + 4 - (d.getDay() || 7));
  const yearStart = new Date(d.getFullYear(), 0, 1);
  const weekNo = Math.ceil((((d - yearStart) / 86400000) + 1) / 7);
  return `${d.getFullYear()}-W${weekNo}`;
};
